















































import { UsersClient } from '@empathybroker/tsclient-users';

import { mapGetters } from 'vuex';

import { CrudForm, UiCheckboxGroup, UiTextbox, UsersPassword } from '../../components';

import { CONTAINER, TYPES } from '../../config';

import { CrudDataTypeEnum, DeviceEnum, RoleEnum } from '../../enums';

import { CrudFormMixin } from '../../mixins/crud-form.mixin';

import { ROUTER_CONSTS } from '../../router/router.consts';

import { AUTH_CONSTS } from '../../store/auth/auth.consts';

export default {
  name: 'users-form',
  mixins: [CrudFormMixin],
  components: {
    CrudForm,
    UsersPassword,
    UiCheckboxGroup,
    UiTextbox
  },
  computed: {
    ...mapGetters(AUTH_CONSTS.moduleName, {
      authToken: AUTH_CONSTS.getters.token
    }),
    valid: function (): boolean {
      if (!this.item.username) {
        return false;
      }
      if (!this.item.email) {
        return false;
      }
      if (!this.item.firstName || !this.item.lastName) {
        return false;
      }
      if (!this.isPasswordValid) {
        return false;
      }
      if (!this.authorizationValid) {
        return false;
      }
      return true;
    },
    authorization: function (): RoleEnum[] {
      return this.item.authorization['*'];
    },
    authorizationValid: function () {
      return !!this.authorization && this.authorization.length > 0;
    },
    roleOptions: function () {
      return Object.entries(RoleEnum).reduce((roleOptions, [roleEnumItemId, roleEnumItemValue]) => {
        if (roleEnumItemId !== RoleEnum.EB_ADMIN) {
          roleOptions.push({
            value: roleEnumItemValue,
            label: (this.$epb.device > DeviceEnum.SMALL_TABLET)
              ? `${ this.messages.fields.roles.values[roleEnumItemId].label } -
          ${ this.messages.fields.roles.values[roleEnumItemId].description }` : this.messages.fields.roles.values[roleEnumItemId].label
          });
        }
        return roleOptions;
      }, []);
    }
  },
  data: function () {
    return {
      dataType: CrudDataTypeEnum.USERS,
      updateMode: (this.$route.name === ROUTER_CONSTS.routes.users.update),
      item: {
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        password: '',
        authorization: { ['*']: [] }, // TODO: support multiple instances
        enabled: true
      },
      messages: this.$epb.messages.tools.users,
      isPasswordValid: false
    };
  },
  methods: {
    onItemLoad: async function (): Promise<void> {
      CrudFormMixin.methods.onItemLoad.bind(this)();
      if (!!this.item.id) {
        const usersClient = CONTAINER.get<UsersClient>(TYPES.UsersClient);
        const authorizationResponse = await usersClient.getRoles(this.authToken, this.item.id);
        this.item.authorization = authorizationResponse.data;

        this.$refs.autorizationCheckboxGroup.initialValue = this.authorization;
        this.$refs.autorizationCheckboxGroup.reset();
      }
    },
    onPasswordChange: function (passwordState): void {
      this.item.password = passwordState.value;
      this.isPasswordValid = passwordState.valid;
    }
  },
  watch: {
    'item.username': function () {
      this.item.username = this.item.username.toLowerCase();
    }
  }
};

